export * from './localize/translate';
export { $localize } from './localize/localize/src/localize';
